import { AbstractFormFragment } from "@components/form/AbstractFormFragment";

export class FileUploadFormFragment extends AbstractFormFragment {
  private input!: HTMLInputElement;
  private button!: HTMLButtonElement;
  private fileList!: HTMLUListElement;
  private fileLimit!: number;
  private accept!: string;

  static getCssClassName() {
    return "comp-form-fileupload";
  }

  initializeNode() {
    this.input = this.node.querySelector("input")!;
    if (!this.input) return this;
    this.fileLimit = parseInt(this.input.getAttribute("maxlength") ?? "");
    this.accept = this.input.getAttribute("accept") || "";
    this.button = this.node.querySelector(".comp-button button")!;
    this.fileList = this.node.querySelector(".comp-form-fileupload__list")!;

    this.button.addEventListener("click", (e) => {
      e.preventDefault();
      this.input.click();
    });

    this.input.addEventListener("change", () => {
      const files = this.input.files ?? [];

      if (new URLSearchParams(window.location.search).has("uploadlog")) {
        Array.from(files).forEach((file) => {
          console.log(`[FileUpload] name=${file.name} type=${file.type}`);
        });
      }

      const invalidFile = this.accept
        ? Array.from(files).find((file) => !this.isFileAccepted(file))
        : undefined;

      if (files.length > this.fileLimit) {
        this.showError("File limit exceeded");
        this.input.files = new DataTransfer().files;

        if (this.fileList) {
          this.fileList.innerHTML = "";
        }
      } else if (invalidFile) {
        const format = invalidFile.name.split(".").pop()?.toLowerCase();
        this.showError(`You cannot select a ${format} file.\nTry again...`);
        this.input.files = new DataTransfer().files;

        if (this.fileList) {
          this.fileList.innerHTML = "";
        }
      } else {
        this.createInputFileList();
      }
    });

    return this;
  }

  private isFileAccepted(file: File): boolean {
    const specifiers = this.accept.split(",").map((s) => s.trim().toLowerCase());
    const fileExt = file.name.split(".").pop()?.toLowerCase() ?? "";
    const fileMime = file.type.toLowerCase();

    return specifiers.some((specifier) => {
      if (specifier.startsWith(".")) {
        return fileExt === specifier.slice(1);
      } else if (specifier.endsWith("/*")) {
        return fileMime.startsWith(specifier.slice(0, -1));
      } else {
        return fileMime === specifier || fileExt === specifier.split("/").pop();
      }
    });
  }

  private removeFile(listItem: HTMLLIElement) {
    const files = this.input.files ?? [];
    const dataTransfer = new DataTransfer();
    const removedFileIndex = Array.from(this.fileList.children).indexOf(
      listItem,
    );

    for (const file of files) {
      const fileIndex = Array.from(files as Iterable<File>).indexOf(file);

      if (removedFileIndex !== fileIndex) {
        dataTransfer.items.add(file);
      }
    }

    this.input.files = dataTransfer.files;
    this.createInputFileList();
  }

  private createInputFileList() {
    const files = this.input.files ?? [];

    if (this.fileList) {
      this.fileList.innerHTML = "";
    }

    for (const file of files) {
      this.createFileListItem(file.name);
    }
  }

  private createFileListItem(fileName: string) {
    const listItem = document.createElement("li");
    const removeButton = document.createElement("button");
    const listItemLabel = document.createElement("span");

    listItemLabel.innerText = fileName;

    removeButton.addEventListener("click", () => {
      this.removeFile(listItem);
    });

    listItem.classList.add("comp-form-fileupload__label");
    removeButton.classList.add("comp-form-fileupload__remove");

    removeButton.title = `Remove file ${fileName}`;
    removeButton.type = "button";
    listItemLabel.title = `File selected: ${fileName}`;

    listItem.appendChild(removeButton);
    listItem.appendChild(listItemLabel);
    this.fileList?.appendChild(listItem);
  }

  private showError(message: string) {
    alert(message);
  }

  hasValue() {
    return this.node.querySelectorAll(".comp-form-fileupload__label").length > 0;
  }
}
